import Vue from 'vue'
import VueApollo from 'vue-apollo'
import { ApolloClient } from 'apollo-client'
// import { createHttpLink } from 'apollo-link-http'
import { createUploadLink } from 'apollo-upload-client'
import { InMemoryCache } from 'apollo-cache-inmemory'
import axios from 'axios'
import { ApolloLink } from 'apollo-link'
Vue.use(VueApollo)
const { buildAxiosFetch } = require('@lifeomic/axios-fetch')
// -------------------- 아폴로 셋팅 ------------------------ //
const CryptoJS = require('crypto-js')
const crypto = require('crypto')
// const encodeByAES56 = (key, data) => {
// 	const cipher = CryptoJS.AES.encrypt(data, CryptoJS.enc.Utf8.parse(key), {
// 		iv: CryptoJS.enc.Utf8.parse(''),
// 		padding: CryptoJS.pad.Pkcs7,
// 		mode: CryptoJS.mode.CBC,
// 	})
// 	return cipher.toString()
// }
const decodeByAES56 = (key, data) => {
	const cipher = CryptoJS.AES.decrypt(data, key)
	return cipher.toString(CryptoJS.enc.Utf8)
}
const createHashedPassword = password => {
	return crypto
		.createHash('sha512')
		.update(password)
		.digest('base64')
}
const authMiddleware = new ApolloLink((operation, forward) => {
	return forward(operation).map(response => {
		if (response.data.trackingCodes) {
			if (response.data.trackingCodes.length > 0) {
				const datas = []
				const secretKey = process.env.VUE_APP_SECRET_KEY + createHashedPassword(response.data.trackingCodes[0].created_at)
				for (let index = 0; index < response.data.trackingCodes.length; index++) {
					const el = response.data.trackingCodes[index]
					const decodeDatas = decodeByAES56(secretKey, el.secret)
					datas.push(JSON.parse(decodeDatas))
				}
				if (response.data.trackingCodesConnection) {
					return { data: { trackingCodes: datas, trackingCodesConnection: response.data.trackingCodesConnection } }
				} else {
					return { data: { trackingCodes: datas } }
				}
			} else return response
		}
		if (response.data.reserveusers) {
			if (response.data.reserveusers.length > 0) {
				const datas = []
				const secretKey = process.env.VUE_APP_SECRET_KEY + createHashedPassword(response.data.reserveusers[0].updated_at)
				for (let index = 0; index < response.data.reserveusers.length; index++) {
					const el = response.data.reserveusers[index]
					const decodeDatas = decodeByAES56(secretKey, el.secret)
					datas.push(JSON.parse(decodeDatas))
				}
				if (response.data.reserveusersConnection) {
					return { data: { reserveusers: datas, reserveusersConnection: response.data.reserveusersConnection } }
				} else {
					return { data: { reserveusers: datas } }
				}
			} else return response
		}
		if (response.data.waitings) {
			if (response.data.waitings.length > 0) {
				const datas = []
				const secretKey = process.env.VUE_APP_SECRET_KEY + createHashedPassword(response.data.waitings[0].created_at)
				for (let index = 0; index < response.data.waitings.length; index++) {
					const el = response.data.waitings[index]
					const decodeDatas = decodeByAES56(secretKey, el.secret)
					datas.push(JSON.parse(decodeDatas))
				}
				if (response.data.waitingsConnection) {
					return { data: { waitings: datas, waitingsConnection: response.data.waitingsConnection } }
				} else {
					return { data: { waitings: datas } }
				}
			} else return response
		}
		if (response.data.eventJoins) {
			if (response.data.eventJoins.length > 0) {
				const datas = []
				const secretKey = process.env.VUE_APP_SECRET_KEY + createHashedPassword(response.data.eventJoins[0].created_at)
				for (let index = 0; index < response.data.eventJoins.length; index++) {
					const el = response.data.eventJoins[index]
					const decodeDatas = decodeByAES56(secretKey, el.secret)
					datas.push(JSON.parse(decodeDatas))
				}
				if (response.data.eventJoinsConnection) {
					return { data: { eventJoins: datas, eventJoinsConnection: response.data.eventJoinsConnection } }
				} else {
					return { data: { eventJoins: datas } }
				}
			} else return response
		} else return response
	})
})

// HTTP connection to the API
// const uploadLink = createUploadLink({
// 	uri: process.env.VUE_APP_BACKEND_URL + '/graphq',
// 	fetch: buildAxiosFetch(axios, (config, input, init) => ({
// 		...config,
// 		onUploadProgress: init.onUploadProgress,
// 	})),
// })
// const httpLink = createHttpLink({
//   // You should use an absolute URL here
//   uri: process.env.BACKEND_HOST+'/graphql'
// })
// Cache implementation
const cache = new InMemoryCache()
// Create the apollo clients
const apolloClient = new ApolloClient({
	// link: uploadLink,
	link: authMiddleware.concat(
		createUploadLink({
			uri: process.env.VUE_APP_BACKEND_URL + '/graphq',
			fetch: buildAxiosFetch(axios, (config, input, init) => ({
				...config,
				onUploadProgress: init.onUploadProgress,
			})),
		}),
	),
	cache,
	bodyParserConfig: {
		limit: '9000mb',
	},
	defaultOptions: {
		watchQuery: {
			fetchPolicy: 'no-cache',
		},
		query: {
			fetchPolicy: 'no-cache',
		},
		mutate: {
			fetchPolicy: 'no-cache',
		},
	},
})
const active = new VueApollo({
	clients: {
		apolloClient,
	},
	defaultClient: apolloClient,
})
export default active
// -------------------- 아폴로 셋팅 ------------------------ //
